<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <section class="page">
        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1" v-for="(item,index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>

        <div class="box">
          <img class="bg" :src="datas.product.img" />
          <ul class="content" :class="[
              ['100010391'].includes(datas.business.rootid)?'content-new':'',
              ['100010381'].includes(datas.business.rootid)?'cleft':'cright'
            ]">
            <template v-for="(item, index) in menu">
              <li @click="toDetail(item.name)" v-if="['100010391'].includes(datas.business.rootid)&&item.name=='检测报告'?false:true" :key="index">{{ item.name }}</li>
            </template>
          </ul>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
let self,map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake09',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      vcode:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      },
      location:null,
      menu: [{
        name: '防伪验证'
      },{
        name: '全程溯源'
      },{
        name: '检测报告',
      },{
        name: '企业风采'
      },{
        name: '企业荣誉'
      },{
        name: '系列产品'
      }]
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.randomCode();
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated () {
    new Swiper('.banner',{
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: true,//可选选项，自动滑动
      loop: true, //可选选项，开启循环
    })
  },
  methods:{
    toDetail(id){
      localStorage.setItem("wwm_ref", JSON.stringify({ template: 'AntiFake09', data: this.datas }));
      this.$router.push({ path: `/Details?type=${id}&template=AntiFake09` }); // 模板路由跳转
    },
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
        console.log(datas)
        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){

        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        datas.verify = response.data.meta.verify; //防伪码
        datas.code = self.code; //二维码
        if(response.data.meta.verify){
          self.vcode = response.data.meta.verify;
        }else{
          self.randomCode();
        }

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);

          if(datas.business.customize_data){
            for(let i in datas.business.customize_data){
              if(datas.business.customize_data[i].key == "经纬度"){
                self.location = datas.business.customize_data[i].value;
              }
            }
          }

        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);

          datas.ref.forEach(item=>{
            let parentIndex = -1;
            item.datas && item.datas.forEach((value, index)=>{
              if(value.type == 0){
                parentIndex = index;
                value.show = false;
              }
              value.index = parentIndex;
            })
          })
          console.log(datas.ref)
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu (data) {
      if(data.type != 2){
        window.location.href = data.url;
      }else{
        this.$router.push({path: "/qr?qr="+data.qr});
      }
    },
    randomCode (){ //生成随机码
      while(self.vcode<100000){
      	self.vcode = Math.floor(Math.random()*1000000);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page{
  height: 100vh;
  background-color: #fbf4e4;
  .banner{
    margin-bottom: 10px;
    img{
      width: 100%;
      display: block;
    }
  }
  .box{
    .bg{
      width: 100%;
    }
    .content{
      top: 10px;
      position: absolute;
      li{
        margin-top: 20px;
        width: 139px;
        line-height: 40px;
        color: #e7340f;
        text-align: center;
        font-size: 20px;
        border-radius: 10px;
        background-color: #fff693;
      }
    }
    .content-new{
      li{
        color: white;
        background-color: #f28e00;
      }
    }
    
    .cleft{
      left: 20px;
    }
    .cright{
      right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake09.vue